<template>
    <div>

     <ul v-for="(product, index) in products"   v-if="qty_arr.length > 0 && products" :key="index">
            <div v-if="instock(product) && product.is_purchasable" >
                <div class="product-qty first"  >

                    <strong>{{ product.price.price_plus_vat }} {{ product.price.currency }} </strong> - {{ product.packaging_qty }} {{ product.packaging_qty_unit }}
                    <div class="pricebox">

                        <div :class="['icon-cart-del',  { 'icon-cart-disabled': qty_arr[index].qty < 1} ]" @click="qty_del(index)" v-on:dblclick="" v-if="!mchange"><img src="/images/icon-minus.svg" alt="" class="img-fluid center-block"></div>
                        <div class="product-qty">
                            {{ qty_arr[index].qty }}
                        </div>
                        <div class="icon-cart-add" @click="qty_add(index, product)" v-on:dblclick=""  v-if="!mchange"><img src="/images/icon-plus.svg" alt="" class="img-fluid center-block"></div>

                    </div>
                </div>
            </div>
            <div  v-else="!instock(product)" >
                <strong>{{ product.price.price_plus_vat }} {{ product.price.currency }}  </strong> - {{ product.packaging_qty }} {{ product.packaging_qty_unit }}
            </div>
        </ul>
        <hr>
        <button v-if="!anyProductPurcasable" type="button" class="float-end btn btn-disabled"    >  {{ __('__JSON__.kosárba teszem')}}  </button>
        <button v-if="anyProductPurcasable" type="button" class="float-end btn btn-product-incart" @click="cart_add"  > {{ __('__JSON__.kosárba teszem')}}   </button>

        <!-- <button v-if="!products[0].is_purchasable" type="button" class="float-end btn btn-disabled"    >  {{ __('__JSON__.kosárba teszem')}}  </button>
        <button v-if="products[0].is_purchasable" type="button" class="float-end btn btn-product-incart" @click="cart_add"  > {{ __('__JSON__.kosárba teszem')}}   </button> -->

         <!-- <button v-if="!products[0].is_purchasable || (products[0].is_purchasable && products[0].inventory_quantity == 0)" type="button" class="float-end btn btn-disabled"    >  {{ __('__JSON__.kosárba teszem')}}  </button>
         <button v-if="(products[0].is_purchasable && products[0].inventory_quantity > 0) || (products[0].is_purchasable && products[0].inventory_quantity == null)" type="button" class="float-end btn btn-product-incart" @click="cart_add"  > {{ __('__JSON__.kosárba teszem')}}   </button> -->
    </div>

</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import mixin from '../../mixin.js'
import { EventBus } from '../../eventbus.js';
export default {
    mixins: [mixin],
    //v-on:keyup="manualchange(index)"
    // props: ['kosar','cikkszam','url','termekfoto','termeknev','ar','mennyisegi_egyseg','penznem','keszletinfo','afa' ],
    props: ['cart', 'products'  ],

    //this.$root.kosar[this.$data.index].qty
    data: function() {
        return {
            mchange: false,
            index: -1,
            qty_arr: []
        }

    },

    computed: {
        anyProductPurcasable: function() {
            let ret = 0
            _.forEach(this.products, function(product) {
                  if (product.is_purchasable) {
                    ret = 1;
                }
            });

            return ret;
        },
        //
        // incart: function() {
        //
        //     var ret;
        //     if (this.$root.cart !== 'undefined') {
        //         ret = this.$root.cart.findIndex((k) => k.product_id == this.product.id) > -1 ? 1 : 0;
        //     } else {
        //         // console.warn('incart UNDEFINED!');
        //     }
        //     return ret;
        //
        // },
        //
        // incart_db: function() {
        //     var ret;
        //     // console.warn('watch: REALCART');
        //     if (this.incart) {
        //         if (this.$root.cart[this.cartindex] != undefined) {
        //             ret = this.$root.cart[this.cartindex].qty;
        //         } else {
        //             ret = 0;
        //         }
        //     } else {
        //
        //         ret  = 0;
        //     }
        //     this.qty = ret;
        //     return "";
        //
        // },

        // cartindex: function() {
        //     //  console.info('termekListaDb cartindex()');
        //     var ret;
        //
        //     if (this.$root.cart !== 'undefined') {
        //
        //         ret = this.$root.cart.findIndex((k) => k.product_id == this.product.id) > -1 ?  this.$root.cart.findIndex((k) => k.product_id == this.product.id)  : -1
        //     } else {
        //         // console.warn('cartindex UNDEFINED!');
        //     }
        //     // console.log('ret='+ ret);
        //     return ret;
        // }
    },
    watch: {
        // realcart: function() {
        //     if (this.incart) {
        //         var self = this;
        //         Vue.nextTick(function () {
        //             // console.warn('nextick?');
        //             self.qty = self.$root.cart[self.cartindex].qty;
        //         });
        //
        //     } else {
        //
        //         ret  = 0;
        //     }
        //     return "";
        // },
        // qty: function() {
        //     var ret;
        //     // console.warn('watch: db');
        //     if (this.incart) {
        //         var self = this;
        //         Vue.nextTick(function () {
        //             // console.warn('nextick?');
        //             if (self.$root.cart[self.cartindex] != undefined) {
        //                 ret = self.$root.cart[self.cartindex].qty;
        //                 self.product.qty = ret;
        //             }
        //
        //         });
        //     } else {
        //
        //         ret = 0;
        //     }
        //
        //     return ret;
        // }

    },
    methods: {
        instock: function(product) {


            if (product.inventory_quantity == null) {
                return 1;
            } else {
                if (product.inventory_quantity == 0) {
                    return 0;
                } else {
                    return 1;
                }
            }

        },
        qty_add: function(index, product) {
            console.log('index add:'+ index, product.inventory_quantity, this.qty_arr[index]['qty']);
            if ((!product.inventory_tracking  && this.qty_arr[index]['qty'] < 98) || (product.inventory_tracking && product.inventory_quantity > 0 && (this.qty_arr[index]['qty'] < product.inventory_quantity)))
            {
                // console.log('+');
                this.qty_arr[index]['qty']++;
                // console.log(this.qty_arr[index]['qty']);
            }
            this.$forceUpdate();
        },
        qty_del: function(index) {
            if (this.qty_arr[index]['qty'] > 0)
            {
                this.qty_arr[index]['qty']--;
            }
            this.$forceUpdate();
        },

        cart_add: function () {
            console.log('roastopus_product_price.vue cart_add()');
            // clearTimeout(this.product.timer);
             var hasQty = this.qty_arr.some(function(item) {
                return item.qty > 0;
            });

            if (!hasQty) return;

            // var resource = this.$http.post('/api/v1/cart', {data: this.qty_arr }).then((response) => {
            axios
            .post('/api/v1/cart', { data: this.qty_arr})
            .then(response => {
                // console.log('response?');
                // console.log(response);
                // console.log('response -end ');
                var self = this;
                self.$root.cart = response.data;
                EventBus.$emit('cart-updated', response.data);
                if (response.data) {
                    this.qty_init();
                    // console.log('self.$root.cart');
                    // console.log(self.$root.cart);
                    // self.mchange = false;
                    this.$notify({
                        type: "success",
                        title: this.__("__JSON__.Kosár"),
                        text: this.__("__JSON__.A terméke(ke)t a kosárba tettem!"),
                        position: "left",
                        group: 'appnotif',
                        // width: notifit_width,
                        // height: 90,
                        autohide: false,
                        timeout:5000,
                    });
                    // console.log
                    //
                    //         // if (google_datalayer_cart) {
                    //         //     ga('send', 'event', {
                    //         //         eventCategory: 'addToCart',
                    //         //         eventAction: 'click',
                    //         //         eventLabel: self.termeknev,
                    //         //         eventValue: 1
                    //         //     });
                    //         // }
                    //         // if (fbq_datalayer_cart) {
                    //         //     fbq('track', 'AddToCart', {
                    //         //         content_ids: [self.cikkszam],
                    //         //         content_type: 'product',
                    //         //         value: self.v_bruttoar,
                    //         //         currency: 'HUF'
                    //         //     });
                    //         // }
                    //     //});
                }
            })

            .catch(error => {
            });





        },
        qty_init() {
            // console.log('qty_init()='+this.prices.length);
            for (var i = 0; i < this.products.length; i++) {
                // console.warn(this.prices[i]);
                this.qty_arr[i] = {
                    "qty": 0,
                    "product_id":  this.products[i].id
                };


            }
            this.$forceUpdate();
            //     console.log('this.qty_arr');
            // console.log(this.qty_arr);
            // console.warn('qty_init() end----- ');
        }

        // cart_del_ajax: function () {
        //     clearTimeout(this.timer);
        //
        //     var resource = this.$http.post(rootdir + '/server/kosarbateszem.php', {cikkszam: this.cikkszam, db: this.qty}).then((response) => {
        //         this.$root.kosar = response.body.cart;
        //         var self = this;
        //         //Vue.nextTick(function () {
        //         self.$root.kosar = response.body.cart;
        //
        //         // this.incartfirst = true;
        //         self.qty = self.getDbFromCart();
        //         ///        });
        //     }, (response) => {
        //         // error callback
        //     });
        //
        //
        //
        // },
        // kosarbol_torol_ajax: function () {
        //     clearTimeout(this.timer);
        //     if (this.termek.delayed_db != 0) {
        //         this.qty = this.termek.delayed_db;
        //
        //     }
        //     this.termek.qty  = 0;
        //     this.qty  = 0;
        //     // console.info('========= kosarbol ajax');
        //     var resource = this.$http.post(rootdir + '/server/kosarbolki.php', {cikkszam: this.cikkszam }).then((response) => {
        //         this.$root.kosar = response.body.cart;
        //         var self = this;
        //         // Vue.nextTick(function () {
        //         self.$root.kosar = response.body.cart;
        //
        //         // this.incartfirst = true;
        //         self.qty = self.getDbFromCart();
        //         // });
        //     }, (response) => {
        //         // error callback
        //     });
        //
        //
        //
        // }
    },
    // data: function() {
    //     return {
    //         mchange: false,
    //         index: -1,
    //         // delayed: false,
    //         // delayed_db: 0,
    //         db: 0,
    //
    //
    //
    //         incartfirst: false,
    //         termek: {
    //             cikkszam: this.cikkszam,
    //             url: this.url,
    //             termekfoto: this.termekfoto,
    //             termeknev: this.termeknev,
    //             ar: this.ar,
    //             //    keszlet_info: this.keszletinfo == 'nincs' ? 'false' : 'true',
    //             mennyisegi_egyseg: this.mennyisegi_egyseg,
    //             penznem: this.penznem,
    //             db: 1,
    //             delayed_db: 0,
    //             delayed: false,
    //             timer: null,
    //             index: -1,
    //
    //         }
    //     }
    //
    // },
    mounted: function () {
        console.log('### roastopus_product_price.vue mounted....');
        this.qty_init();
        // console.log('this.prices=');
        // console.log(this.prices);
        // console.log('----');
        this.$forceUpdate();
        // this.qty = this.getQtyFromCart();
        // console.log('this.prices.length=' + this.prices.length);
        // for (var i = 0; i < this.prices.length; i++) {
        //     // var newObj = {};
        //     // newObj.qty = 0;
        //     // newObj.product_id = this.prices[i].id;
        //     // Vue.set(this.prices[i],'qtydata', newObj);
        //     // this.prices[i].push(dataobj);
        //     this.qty_arr[i] = {
        //         "qty": 0,
        //         "product_id":  this.prices[i].id
        //     };
        //     // this.qty_arr[i]["product_id"] = prices[i][];
        //     // console.warn(i+ ':');
        //     // console.warn(this.qty_arr);
        //         // console.warn(this.qty_arr.length);
        // }


        // console.log('==== qty_arr:');
        // console.warn(this.prices);
        // console.warn(this.qty_arr);
        // console.warn(this.qty_arr.length);
    }


}

</script>
<style media="screen">
ul {
    list-style: none;
    padding-left:0;
}
</style>
